module.exports = __webpack_public_path__ + "static/media/WelcomeLetterImage.dc41f323.png";